import { getLanguageFromPath } from "utils/helpers";

export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    const lang = getLanguageFromPath(window.location.pathname);
    document.documentElement.lang = lang;
  }
};

export const onRouteUpdate = ({ location }) => {
  const lang = getLanguageFromPath(location.pathname);
  document.documentElement.lang = lang;
};
